import { IFeaturePoll } from '../../../../types/rest/IRestAuthUser';
import { IApplicationState } from '../../../../types/types';
import { getAuthUser } from './getAuthUser';

export const getAuthUserFeaturePoll = (
    state: IApplicationState
): IFeaturePoll => {
    return getAuthUser(state).featurePoll;
}
